module.exports = __webpack_public_path__ + "media/scena_2.7737f13b.mp4";